import React from 'react';
import appLogo from '../../assets/app-logo.png';
import './AppDownloadCTA.css';

const AppDownloadCTA = ({
  title = 'Start Your Travel Journey with VOIA',
  subtitle = 'Track your visited countries, plan trips, and connect with travelers worldwide.',
}) => {
  return (
    <div className="appDownloadCta">
      <div className="appDownloadCtaCard">
        <img src={appLogo} alt="VOIA" className="appDownloadCtaLogo" />
        <div className="appDownloadCtaContent">
          <h3 className="appDownloadCtaHeading">{title}</h3>
          <p className="appDownloadCtaSubtext">{subtitle}</p>
          <div className="appDownloadCtaBadges">
            <a
              href="https://apps.apple.com/pt/app/voia-travel/id6747190886?l=en-GB"
              target="_blank"
              rel="noopener noreferrer"
              className="appDownloadCtaBadgeLink"
            >
              <img src="/assets/app_store_badge.svg" alt="Download on the App Store" className="appDownloadCtaBadge" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.voia.travel.mobile"
              target="_blank"
              rel="noopener noreferrer"
              className="appDownloadCtaBadgeLink"
            >
              <img src="/assets/google_play_badge.png" alt="Get it on Google Play" className="appDownloadCtaBadge" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadCTA;
